import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { getMuiTheme } from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
// styles
import useMediaQuery from '@material-ui/core/useMediaQuery';

import useStyles from './styles';

import { getQuickCreateView, submitEditView } from "../../../../store/actions/edit.actions";
import { toast } from "react-toastify";
import { Grid, useTheme, Paper, Button, Dialog,  CircularProgress } from '@material-ui/core';
import { TabPanel, ControlledAccordions } from '../../..';
import { validateForm } from '../../../../common/utils';
import { pathOr, clone } from 'ramda';
import { Scrollbars } from 'react-custom-scrollbars';
import { calculate_duration, add_custom_duration } from "../../../../common/duration_dependency";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';
import { Skeleton } from '../../../../components';


export default function QuickCreate({ calendarView = false,selectedDate, openQuickCreateDialog, setOpenQuickCreateDialog, whichQuickCreate, parent_name, parent_id, parent_type, setIsSubpanelUpdated, setValue, value, view = 'Detail',calendarViewType=null,initialData={},isEmailDetailView=false }) {
    const dispatch = useDispatch();
    const history = useHistory();
    //console.log("initialData",initialData);
    const [data, setData] = useState([]);
    const [moduleLable, setModuleLable] = useState(whichQuickCreate);
    const [loading, setLoading] = useState(false);
    const [module, setModule] = useState(whichQuickCreate);
    let [initialValues, setInitialValues] = useState({});
    const [fields, setFields] = useState({});
    const [errors, setErrors] = useState({});
    const classes = useStyles();
    const currentTheme = useTheme();
    const fullScreen = useMediaQuery(currentTheme.breakpoints.down(calendarView?"md":"sm"));

    //var isTab = handleCheck(data, 'tab');
    var isTab = false;
    const { editViewLoading } = useSelector((state) => state.edit);
    const { userPreference, config } = useSelector((state) => state.config);
    const calendar_format = pathOr(config.default_date_format, ['attributes', 'global', 'calendar_format'], userPreference);
    const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_format'], userPreference);
    const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global', 'time_reg_format'], userPreference);
    const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global', 'date_reg_positions'], userPreference);
    const configurator = pathOr([], ['hideShowConf', 'appConfigurator', module], config);
	const {disabledAlways,hiddenAlways,...rest}= configurator;
	let [hiddenAll, setHiddenAll] = useState({hidden:hiddenAlways || [],disabled:disabledAlways || []});
    const {currentUserData} = useSelector((state) => state.config);
    const defaultReminderData = [{"idx":0,"id":"","popup":true,"email":true,"timer_popup":"1800","timer_email":"3600","del_invitees":[],"invitees":[{id:"",module_id:pathOr("",["data","id"],currentUserData),module:"Users","value":pathOr("",["data","attributes","name"],currentUserData),"name":pathOr("",["data","attributes","name"],currentUserData),"email":pathOr("",["data","attributes","email1"],currentUserData)}]}];



    const getQuickCreateData = useCallback(

        (module) => {
            dispatch(getQuickCreateView(module,selectedDate,calendarViewType)).then(function (res) {

                if (res) {
                    setData(pathOr([], ['data', 'templateMeta', 'data'], res));
                    setModuleLable(pathOr([], ['data', 'module_label'], res));
                } else {
                    toast('Something went wrong!');
                }
                setLoading(false)
            });
        },
        [dispatch],
    );
    useEffect(() => {
        setLoading(true)
        getQuickCreateData(module)
        setErrors({});
        setFields({});
        setInitialValues({});
//  console.log(module)
    }, [module]);

    useEffect(
        () => {
            if (data.length) {
                let initialState = [];
                let fieldState = [];
                Object.keys(data).map((row) => {
                    setValues(data[row].attributes, initialState, fieldState);
                    data[row].panels &&
                        data[row].panels.map((panelRow) => {
                            setValues(panelRow.attributes, initialState, fieldState);
                        });
                });

                initialValues = initialState;
                //console.log("initialValues",initialValues);
                setInitialValues({ ...initialValues, ...initialState })
                if (module === 'Meetings') {
                    let initialValuesData = clone(initialValues);
                    let duration = { duration: initialValuesData.duration || '', duration_hours: initialValuesData.duration_hours || '', duration_minutes: initialValuesData.duration_minutes || '' };
                    //if(!parent_id){
                    duration.duration_hours = 0;
                    duration.duration_minutes = 15;
                    duration.duration = 900;
                    //}

                    setInitialValues({ ...initialValuesData, reminders: defaultReminderData,...duration });
                }
            }
        }, [data]
    );

    const setValues = (attributes, initialState, fieldState) => {
        attributes.map((rowField) => {
            rowField.map((field) => {
                setDependencyHidden(field,field.value);
                // console.log(field)	
                if (field.name === 'parent_name') {
                    return (
                        field.name ? (initialState[field.name] = parent_name ? { parent_name, parent_id, parent_type } : '') : null,

                        field.name ? (fields[field.name] = field) : null
                    );

                } else if (field.name === 'duration') {
                    return (
                        field.name ? (initialState[field.name] = field.value ? field.value : '0') : null,
                        field.name ? (initialState['duration_hours'] = field.duration_hours || '0') : null,
                        field.name ? (initialState['duration_minutes'] = field.duration_minutes || '0') : null,
                        field.name ? (fields[field.name] = field) : null

                    );
                }else if (isEmailDetailView) {                   
                    return (
                        field.name ? (initialState[field.name] = initialData[field.name] ? initialData[field.name] : '') : null,

                        field.name ? (fields[field.name] = field) : null
                        );
                } 
                else if(field.module===parent_type){
                    return (
                        field.name ? (initialState[field.name] = parent_id ? { 'id':parent_id, 'value':parent_name } : '') : null,

                        field.name ? (fields[field.name] = field) : null
                    );
                }else{
                    return (
                        field.name ? (initialState[field.name] = field.value ? field.value : '') : null,
                        field.name ? (fields[field.name] = field) : null
                    );
                }

            });
        });
        // console.log("QuickInitialValues",initialState);

    };
    const setDependencyHidden = (field,value) =>{
        if(rest){
            const innerHiddenAlways = Object.values(rest).find(o =>o.fieldsSel[0] ===field.name);
           // console.log(innerHiddenAlways)
            const newCaptureCond = pathOr([], ['condition'], innerHiddenAlways);
    
            const innCond = Object.values(newCaptureCond).find(o => o.field_value[0] === field.options ? field.options[value] : field.type==='bool'?value===0?'false':value?'true':'false':value);
            const hiddField = pathOr([], ['hiddenField'], innCond);
            if(field.type==='bool'){
            
                if (value==='0' || value===false) {
                    let array3 = [...hiddenAll['hidden'], ...hiddField];
                    array3 = array3.filter((item, index) => {
                        return (array3.indexOf(item) == index)
                    })
                    setHiddenAll({ ...hiddenAll, 'hidden': array3 })
                    
                    // console.log("newValif22", array3, hiddenAll)
            
                } else if(value!=='') {
                    let array3 = [...hiddenAll['hidden'], ...hiddField];
                    array3 = hiddenAll['hidden'].filter((item, index) => {
                        return (hiddField.indexOf(item) !== index)
                    })
                    // console.log("newValelse22", array3)
                    setHiddenAll({ ...hiddenAll, ['hidden']: array3 })
    
                }
            }else{
            if(innerHiddenAlways && value){
            
        
                    const innerHiddenAlways2 = field.options?Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value])?Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value]):Object.values(newCaptureCond).find(o =>o.field_value[0] ===value):Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value]);
                    // console.log("innerHiddenAlways2",innerHiddenAlways2,field,value,Object.values(innerHiddenAlways.condition))
                    if(innerHiddenAlways2 && hiddField){
                
                    let array3 = [...hiddenAll['hidden'], ...hiddField];
                
                     array3 = array3.filter((item,index)=>{
                        return (array3.indexOf(item) == index)
                     })
    
                     setHiddenAll({...hiddenAll,['hidden']:array3})
                    //  console.log("if",array3)
                    }else{
                        setHiddenAll({...hiddenAll,['hidden']:hiddenAll['hidden']})
                        // setHiddenAll(hiddenAlways)
                        // console.log("elssssse",hiddenAll)
    
                    }
                }
            }
            }

	}
    const handleDateTimeChange = (date) => {
        let current_datetime = new Date(date);
        return current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2) + " " + ("0" + current_datetime.getHours()).slice(-2) + ":" + ("0" + current_datetime.getMinutes()).slice(-2) + ":" + ("0" + current_datetime.getSeconds()).slice(-2)
    };

    const getFormatedValue = () => {
        let init = clone(initialValues);
        // console.log("init", init)
        for (let key in init) {
            if (typeof init[key] === "object" && key === 'parent_name') {
                init = { ...init, ...init[key] }
            }
            // if(key==='filename'){
            //     init = { ...init, [key]:[init[key]] }
            // }
            // if (key.includes('date')) {
            //     let formatedDate = handleDateTimeChange(init[key]);
            //     init = { ...init, [key]: formatedDate }
            // }

        }

        // setInitialValues(init);
        return init;
    }
    const getBase64 = (file, cb) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            // reader.onload = () => resolve({ 'file_name': file.name, 'file_content': reader.result.replace(/^data:.+;base64,/, '') });
            reader.onload = () => resolve({ 'name': file.name, 'file_content': reader.result });
            reader.onerror = error => reject(error);
        });
    }

    const onChange = (field, value) => {
        setDependencyHidden(field,value);
        if (field.type === "relate") {
			setInitialValues({ ...initialValues, [field.name]: { 'value': value.value, 'id': value.id } });
			return;
		} 
        else if (field.type === 'file') {
            if (module === 'Documents') {
                value ? getBase64(value).then(
                    data => setInitialValues({ ...initialValues, [field.name]: [data], document_name: value.name || '', revision: '1', status_id: 'Active' })
                ) : setInitialValues({ ...initialValues, [field.name]: [{ name: null, file_content: '' }], document_name: '' || '', revision: '', status_id: '' })
            } else {
                value ? getBase64(value).then(
                    data => setInitialValues({ ...initialValues, [field.name]: [data] })

                ) : setInitialValues({ ...initialValues, [field.name]: [{ name: null, file_content: '' }] })
            }
            return;
        }
        // initialValues[field.name] = value;
        setInitialValues({ ...initialValues, [field.name]:value });
        if (module === 'Meetings' && (field.name === 'date_start' || field.name === 'date_end')) {
            let initialValuesData = clone(initialValues);
            initialValuesData[field.name] = value;
            let date_start = initialValuesData.date_start || '';
            let date_end = initialValuesData.date_end || '';
            let duration = { duration: initialValuesData.duration || '', duration_hours: initialValuesData.duration_hours || '', duration_minutes: initialValuesData.duration_minutes || '' };
            if (date_start && date_end) {
                duration = calculate_duration(date_start, date_end, calendar_format, date_reg_format, date_reg_positions, time_reg_format);
                handleMeetingDuration(data, duration.duration);
            }
            setInitialValues({ ...initialValuesData, ...duration });
        }
       
    };
    const handleMeetingDuration = (data, duration) => {
        let cstm = add_custom_duration(duration);
        data[0]['attributes'][3][0].options[cstm.value] = cstm.label;
        data[0]['attributes'][3][0].value = cstm.value;
    }

    const onSubmit = async (data) => {
        let view = 'QuickCreate';
        try {
            dispatch(submitEditView(data, '', module, history, view)).then(function (res) {
                //console.log("rrrrres", res.data)
                
                    if (res && res.data.id) {
                        toast("Record created successfully...!")
                        setOpenQuickCreateDialog(false);
                        setIsSubpanelUpdated(true)
                        if (!calendarView) {
                            setValue(value)
                        }


                    } else {
                        toast(res.ok ? pathOr('', ['data', 'meta', 'message'], res) : pathOr('', ['data', 'errors', 'detail'], res));
                    }
                
            });
        } catch (e) {
            toast('Something went wrong!');
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        let validate = validateForm(fields, initialValues, { calendar_format, date_reg_format, time_reg_format, date_reg_positions });
        setErrors(validate.errors);
        if (validate.formIsValid) {
            var submitData = {
                data: {
                    type: module,
                    attributes: getFormatedValue(),
                }
            };
            if (!initialValues.hasOwnProperty("parent_name")) {
                submitData['data']['relateBean'] = [{
                    "type": parent_type,
                    "id": parent_id
                }]
            }
            onSubmit(submitData);
        }
    }    

    const handleClose = () => {
        setOpenQuickCreateDialog(false);
    };

    const innerView = () => {
        return <div className={classes.root}>
            <form onSubmit={handleSubmit} className={classes.root} noValidate autoComplete="off">
                <Paper className={classes.paper}>
                    <Grid container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={2}>
                        {loading && !data.length && !initialValues.length ? !calendarView ? <CircularProgress /> : null :
                            <>
                            <Grid item>
                                {calendarView ?
                                    <FormControl component="fieldset">
                                        <RadioGroup row aria-label="position" name="position" defaultValue={module}>
                                            <FormControlLabel value="Meetings" onChange={() => { setModule("Meetings"); setModuleLable("Meetings") }} control={<Radio color="primary" />} label="Schedule Meeting" />
                                            <FormControlLabel value="Calls" onChange={() => { setModule("Calls"); setModuleLable("Calls") }} control={<Radio color="primary" />} label="Log Call" />
                                            <FormControlLabel value="Tasks" onChange={() => { setModule("Tasks"); setModuleLable("Tasks") }} control={<Radio color="primary" />} label="Create Task" />
                                        </RadioGroup>
                                    </FormControl> : <strong style={{ fontSize: '16px' }}>{moduleLable}</strong>
                                }
                            </Grid>
                            <Grid item>
                                {editViewLoading ? 
                                <Button variant="contained" size="small" color="primary" >
                                    Saving  <CircularProgress size={14} style={{ marginLeft: 10, color: "White" }} />
                                </Button> : 
                                <Button type="submit" variant="contained" size="small" color="primary">Save</Button>}
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    onClick={handleClose}
                                    className={classes.margin}
                                >Cancel</Button>
                            </Grid>
                            </>}

                    </Grid>
                </Paper>
                <Scrollbars autoHide autoHeight autoHeightMax={500}>

                    <Paper className={view !== 'Calendar' ? classes.paperEdit : ''}>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm container>
                                {loading && calendarView ? <div style={{ minHeight: '500px', minWidth: '500px' }}><Skeleton /></div> :
                                    isTab ? (
                                        initialValues ? <TabPanel
                                            data={data}
                                            errors={errors}
                                            initialValues={initialValues}
                                            module={module}
                                            onChange={onChange}
                                            hiddenAll={hiddenAll}
                                        /> : null
                                    ) : (

                                        initialValues ? <ControlledAccordions
                                            data={data}
                                            errors={errors}
                                            initialValues={initialValues}
                                            module={module}
                                            headerBackground="true"
                                            onChange={onChange}
                                            hiddenAll={hiddenAll}
                                        // getDataLine={getDataLine}
                                            quickCreate={true}
                                        /> : null
                                    )}
                            </Grid>
                        </Grid>

                    </Paper>
                </Scrollbars>

            </form>
        </div>

    }
    return (
        <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
            {view !== 'Calendar' ? 
            <Dialog   
                fullScreen={fullScreen}
                fullWidth={calendarView?true:false}
                maxWidth={calendarView?"md":"md"}  
                open={openQuickCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title" >{innerView()}
            </Dialog> : innerView()}
        </MuiThemeProvider>
    );
}
